export const LOCAL_API_URL = `http://localhost:7071/api`;
export let deploymentURL = "";
export let AD_tenantID = "";
export let AD_appId = "";
export let AD_appSecret = "";
export let SUBSCRIPTION_KEY = "";
export let API_URL = "";
export let BACKEND_API_URL = "";
export let PLANNING_API_URL = "";
export let GrayBar_API_URL = "http://localhost:7071/api";
export let GRAYBAR_BACKEND_API_URL = "";
export let INSTRUMENTATION_KEY = "";
 
const env = process.env.NODE_ENV;
 
if (env === "production") {
    deploymentURL =
        "https://WdAdvantage-catman-c8bvcdf9bjewh0da.a01.azurefd.net/";
    AD_tenantID = "8fba9776-ec00-4802-bf6c-8477d5e7d4be";
    AD_appId = "52ab0de7-8470-4a78-ae70-c037fbf2d39c";
    AD_appSecret = "01C8Q~gx5mTisUQhhF0X1uv3hCT6E1T55lfRKcK4";
    SUBSCRIPTION_KEY = "a79c855d43924086bb3cba30f1d917b0";
    BACKEND_API_URL = `https://graybar-marginbrain-api-services.azure-api.net/wdadvantage-marginbrain-functionapp`;
    PLANNING_API_URL = `https://graybar-planning-api-services.azure-api.net/graybar-gta-v1`;
    GRAYBAR_BACKEND_API_URL = `${GrayBar_API_URL}`;
    INSTRUMENTATION_KEY = "10e27042-027a-4b97-81b2-a21df8bd59e3";
} else if (env === "development") {
    deploymentURL =
        "https://WdAdvantage-catman-c8bvcdf9bjewh0da.a01.azurefd.net/";
    AD_tenantID = "8fba9776-ec00-4802-bf6c-8477d5e7d4be";
    AD_appId = "52ab0de7-8470-4a78-ae70-c037fbf2d39c";
    AD_appSecret = "01C8Q~gx5mTisUQhhF0X1uv3hCT6E1T55lfRKcK4";
    SUBSCRIPTION_KEY = "a79c855d43924086bb3cba30f1d917b0";
    BACKEND_API_URL = `https://graybar-marginbrain-api-services.azure-api.net/wdadvantage-marginbrain-functionapp`;
    PLANNING_API_URL = `https://graybar-planning-api-services.azure-api.net/graybar-gta-v1`;
    GRAYBAR_BACKEND_API_URL = `${GrayBar_API_URL}`;
    INSTRUMENTATION_KEY = "10e27042-027a-4b97-81b2-a21df8bd59e3";
} else {
    deploymentURL =
        "https://WdAdvantage-catman-c8bvcdf9bjewh0da.a01.azurefd.net/";
    AD_tenantID = "8fba9776-ec00-4802-bf6c-8477d5e7d4be";
    AD_appId = "52ab0de7-8470-4a78-ae70-c037fbf2d39c";
    AD_appSecret = "01C8Q~gx5mTisUQhhF0X1uv3hCT6E1T55lfRKcK4";
    SUBSCRIPTION_KEY = "a79c855d43924086bb3cba30f1d917b0";
    BACKEND_API_URL = `https://graybar-marginbrain-api-services.azure-api.net/wdadvantage-marginbrain-functionapp`;
    PLANNING_API_URL = `https://graybar-planning-api-services.azure-api.net/graybar-gta-v1`;
    GRAYBAR_BACKEND_API_URL = `${GrayBar_API_URL}`;
    INSTRUMENTATION_KEY = "10e27042-027a-4b97-81b2-a21df8bd59e3";
}